import { Component, OnInit, Input } from '@angular/core';
import { environment } from '@environment';

import { BaseComponent } from '@core/components/base/base.component';

@Component({
    selector: 'app-install-eatclub',
    templateUrl: './install-eatclub.component.html',
    styleUrls: ['./install-eatclub.component.scss'],
    standalone: true
})
export class InstallEatclubComponent extends BaseComponent implements OnInit {

	@Input() type: string;
	app_link: string;

  	constructor() {
        super();
  	}

  	ngOnInit() {

        if (this.isServer) {
            this.app_link = '';
            return;
        }

  		const userAgent = navigator.userAgent;
  		if (/iPad|iPhone|iPod|Mac/.test(userAgent)) {
  			this.app_link = environment.app_link.apple;
    	} else {
			this.app_link = environment.app_link.google;
		}
  	}
}
